"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getCountryCode = require("./getCountryCode");
Object.keys(_getCountryCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getCountryCode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getCountryCode[key];
    }
  });
});
var _getGeolocationData = require("./getGeolocationData");
Object.keys(_getGeolocationData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getGeolocationData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getGeolocationData[key];
    }
  });
});
